export function wave_triangle({compId,shapeHeight,animationSpeed,flipAnimation}) {
  let flipA = -4.5,
      flipB = -4;
  if(flipAnimation){
    flipA = -0.5;
    flipB = -1;
  }
  return `
  <pattern class="patternSingle" id="single_${compId}" patternUnits="userSpaceOnUse" viewbox="0 0 1920 240" x="50%" y="0" height="${shapeHeight}" width="1920" preserveAspectRatio="xMidYMax meet" patternTransform="translate(0 0)">
    <path d="M0,0h3.9c10.7,0,21.3,1.3,31.7,4l892.8,227.9c20.8,5.3,42.6,5.3,63.3,0L1884.4,4c10.3-2.6,21-4,31.7-4h3.9v240H0V0z">
      <animate attributeType="xml" attributeName="d"
        values="M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 111.9 C 949.2 117.2 971 117.2 991.7 111.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 231.9 C 949.2 237.2 971 237.2 991.7 231.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 111.9 C 949.2 117.2 971 117.2 991.7 111.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z"
        keyTimes="0;0.5;1"
        keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
         dur="${5 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path opacity="0.66" d="M0,0h3.9c10.7,0,21.3,1.3,31.7,4l892.8,227.9c20.8,5.3,42.6,5.3,63.3,0L1884.4,4c10.3-2.6,21-4,31.7-4h3.9v240H0V0z">
      <animate attributeType="xml" attributeName="d"
        values="M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 71.9 C 949.2 74.2 971 74.2 991.7 71.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 191.9 C 949.2 197.2 971 197.2 991.7 191.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 71.9 C 949.2 74.2 971 74.2 991.7 71.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z"
        keyTimes="0;0.5;1"
        keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
        begin="${flipA * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path opacity="0.33" d="M0,0h3.9c10.7,0,21.3,1.3,31.7,4l892.8,227.9c20.8,5.3,42.6,5.3,63.3,0L1884.4,4c10.3-2.6,21-4,31.7-4h3.9v240H0V0z">
      <animate attributeType="xml" attributeName="d"
        values="M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 21.9 C 949.2 23.2 971 23.2 991.7 21.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 151.9 C 949.2 157.2 971 157.2 991.7 151.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z;
        M 0 0 H 3.9 C 14.6 0 25.2 1.3 35.6 4 L 928.4 21.9 C 949.2 23.2 971 23.2 991.7 21.9 L 1884.4 4 C 1894.7 1.4 1905.4 0 1916.1 0 H 1920 V 240 H 0 V 0 Z"
        keyTimes="0;0.5;1"
        keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
        begin="${flipB * animationSpeed}s" dur="${5 * animationSpeed}s" repeatCount="indefinite" />
    </path>
  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${-((shapeHeight*8)/2+2560-2)}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="0" x="50%" height="${shapeHeight}" fill="white"></rect>
  <rect shape-rendering="crispEdges" style="transform: translate(${(shapeHeight*8)/2-2}px,0)" class="animdiv-mask animdiv-mask-top" width="2560" y="0" x="50%" height="${shapeHeight}" fill="white"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}